import styled from "styled-components";

export const FormInput = styled.input`
  width: 100%;
  height: 48px;
  outline: none;
  padding: 16px 16px;
  border: 1px solid #ececec;
  border-radius: 12px;
  ${'' /* font-size: 1rem; */}
  ${'' /* color: #C1C1C7; */}
  transition: box-shadow 0.3s;
  font-family: Poppins;
  font-weight: 500;
  font-size: 14px;
  line-height: 155%;
  letter-spacing: 0%;
  vertical-align: middle;

  &:focus {
    box-shadow: 0 0 0 2px rgb(170, 173, 254, 0.5);
  }
  &::placeholder{
    color:#C1C1C7;
  }
`;
